var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"clinical-trial"},[_c('graph-triple-panel',{attrs:{"graph-title":"临床试验知识图谱","table-title":"临床试验三元组表格","graph-data":_vm.graphData,"triples":_vm.triples,"page-size":10}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }